import { LocalStorage2faKey } from '@pkg/types';

import { handleRemoveAuthTokens, setIsAuthenticated, useAuthTokens } from '@app/store/zustand/Auth/useUserTokens';

import {
    ACTION_REMOVE_TOKENS,
    ACTION_SET_LAST4,
    ACTION_SET_LOADING_USER,
    ACTION_SET_MAGIC_LINK_EMAIL,
    ACTION_SET_TOKENS,
    type AuthActionTypes,
    type AuthState,
} from '../types/auth';

export const DEFAULT: AuthState = {
    hasPassword: false,
    isDraftUser: false,
    magicLinkEmail: '',
    last4: '',
    loadingUser: false,
};

const handleRemoveTokens = (keepRefreshToken?: boolean) => {
    handleRemoveAuthTokens({ keepRefreshToken });
    localStorage.removeItem(LocalStorage2faKey.TimeSinceRequire);
    localStorage.removeItem(LocalStorage2faKey.TimeSincePostPurchase);
};

export function auth(state: AuthState = DEFAULT, action: AuthActionTypes): AuthState {
    switch (action.type) {
        case ACTION_SET_TOKENS:
            useAuthTokens.setState({ token: action.tokens, hasPassword: action.tokens.has_password || false });
            setIsAuthenticated();
            return {
                ...state,
                isDraftUser: action.isDraftUser || false,
            };
        case ACTION_REMOVE_TOKENS:
            handleRemoveTokens();
            return { ...DEFAULT };
        case ACTION_SET_MAGIC_LINK_EMAIL:
            return { ...state, magicLinkEmail: action.magicLinkEmail };
        case ACTION_SET_LAST4:
            return { ...state, last4: action.last4 };
        case ACTION_SET_LOADING_USER:
            return { ...state, loadingUser: action.loadingUser };

        default: {
            return state;
        }
    }
}
